<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import useUser from '../../../../Composables/User/useUser.ts'
import Role from '../../../../Constants/Role'
import RentCalculatorModal from '../Calculator/RentCalculatorModal.vue'
import AmountCalculatorModal from '../Calculator/AmountCalculatorModal.vue'
import { isTheme } from '../../Utils/isTheme'

export default {
  components: { AmountCalculatorModal, RentCalculatorModal },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    finance: { type: Object, required: true },
    company: { type: Object, required: true },
    status: { type: String, required: true },
    rentInfo: { type: Object, required: true },
  },

  data() {
    return {
      displayTTC: false,
    }
  },
  setup() {
    const { isReadOnly } = useUser()

    return { isReadOnly }
  },
  computed: {
    hasLevel() {
      return this.rentInfo.hasLevel
    },
    periodLabel() {
      return this.$t(`contract.information.rentHt.${this.finance?.period.id}`)
    },
    hasServiceLevel() {
      return this.finance.services?.length > 0
    },
    isSigned() {
      let signed = ['CLIENT_SIGNED', 'COMPANY_SIGNED', 'DELIVERED', 'CHECKED', 'ORDERED', 'WAITING', 'COMPLETE']
      return signed.includes(this.status)
    },
    canEditRent() {
      return this.hasRole(Role.RENT_EDIT) && (!this.isSigned || isTheme('financia'))
    },
  },

  methods: {
    setAmountInsurance(rent) {
      for (const [key, service] of Object.entries(this.finance.services)) {
        if (service.active) {
          rent = parseFloat(rent) + parseFloat(service.amount)
        }
      }

      return this.$n(Number(rent), 'currency')
    },
    hasServices() {
      for (const [key, service] of Object.entries(this.finance.services)) {
        if (service.active && (service.level || service.amount)) {
          return true
        }
      }
      return false
    },
    sendLevel(rentObject) {
      if (this.hasLevel) {
        let index = this.rentInfo.levels.findIndex((r) => r.id === rentObject.rent.id)
        if (index !== -1) {
          this.setValue(this.finance, 'rent', rentObject.rent)
        }
      } else {
        this.rentInfo = rentObject
      }
    },
    sendRentUp(rent) {
      this.sendLevel({ rent: rent })
      this.$emit('set-rent', rent)
    },
    showCalculator(rentId) {
      if (this.company?.computeAmountMode) {
        this.$refs['modal-amount-calculator'].showForm()
      } else if (this.company?.computeRentMode) {
        this.$refs[`modal-rent-calculator${rentId}`].showForm()
      }
    },
  },
}
</script>
<template>
  <div>
    <table class="table table-striped table-hover fs-16" cellspacing="0">
      <thead>
        <tr>
          <th class="text-center font-weight-bold">{{ $t('simulation.result.table.duration') }}</th>

          <th class="text-center font-weight-bold">{{ periodLabel }}</th>

          <th v-if="hasServices()" class="text-center font-weight-bold">
            {{ $t('simulation.result.table.services') }}
          </th>

          <th v-if="rentInfo.hasLevel" class="text-center font-weight-bold">
            {{ $t('level.finalOutstanding.title') }}
          </th>

          <th v-if="canEditRent"></th>
        </tr>
      </thead>
      <tbody>
        <tr e2e-row="contractRent">
          <td :class="'text-center' + (hasLevel ? ' text-decoration-through' : '')" e2e-data="contractRentDuration">
            {{ rentInfo.duration }} {{ $t('time.month') }}
          </td>

          <td :class="'text-center' + (hasLevel ? ' text-decoration-through' : '')" e2e-data="contractRentAmount">
            {{ $n(Number(rentInfo.rent), 'currency') }}
          </td>

          <td
            v-if="hasServices()"
            :class="'text-center' + (hasLevel ? ' text-decoration-through' : '')"
            e2e-data="contractRentServiceAmount"
          >
            {{ setAmountInsurance(rentInfo.rent) }}
          </td>

          <td></td>

          <td class="text-center" v-if="canEditRent">
            <button class="btn btn-primary" @click="showCalculator(rentInfo.id)" e2e-button="contractRentUpdate">
              <span v-if="hasLevel">{{ $t('level.hasLevel') }}</span>
              <span v-else><i class="fa fa-lg fa-edit"></i></span>
            </button>

            <RentCalculatorModal
              v-if="company.computeRentMode"
              in-contract
              :rent-id="rentInfo.id"
              :ref="'modal-rent-calculator' + rentInfo.id"
              :has-level="hasLevel"
              :has-service-level="hasServiceLevel"
              :margin-calculation-method="company.marginCalculationMethod"
              @rent-updated="sendRentUp"
              @set-level="sendLevel"
            />

            <AmountCalculatorModal
              v-if="company.computeAmountMode"
              ref="modal-amount-calculator"
              :rent-id="rentInfo.id"
              @rent-updated="sendRentUp"
            />
          </td>
        </tr>
        <tr v-if="rentInfo.hasLevel" v-for="(level, index) in rentInfo.levels">
          <td class="text-center">{{ level.duration }} {{ $t('time.month') }}</td>
          <td class="text-center">{{ $n(Number(level.amount), 'currency') }}</td>
          <td v-if="hasServices()" class="text-center">
            {{ level.amountService ? $n(Number(level.amountService), 'currency') : '' }}
          </td>
          <td class="text-center">{{ $n(Number(level.outstanding), 'currency') }}</td>
          <td v-if="canEditRent"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
